module.exports = __webpack_public_path__ + "static/media/umpire-cap.3b68ca49.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/umpire-cap.png
// module id = 246
// module chunks = 0